import { messages } from '@databases/intl/messages';
import { getBridgeAPI } from '@databases/utils/database/bridge';
import { UnfoundEntryError, UnfoundFieldError } from '@databases/utils/errors';
import { isStandalone } from '@databases/utils/utils';
import React, { FunctionComponent, useEffect } from 'react';
import { useIntl } from 'react-intl-next';

import { FatalErrorProps } from './ErrorBoundary';
import GenericErrorState from './GenericErrorState';

const DatabaseFatalError: FunctionComponent<FatalErrorProps> = ({ error }) => {
  useEffect(() => {
    const markBridgeLoadFailed = async () => {
      (await getBridgeAPI())?.onContentLoadFailed?.(error, {});
    };

    if (isStandalone()) {
      markBridgeLoadFailed();
    }
  }, [error]);

  const { formatMessage } = useIntl();

  const getErrorMessage = (error: Error): string => {
    if (error instanceof UnfoundEntryError) {
      return formatMessage(messages['error-message.could-not-find-entry'], {
        entryId: error.entryId,
      });
    } else if (error instanceof UnfoundFieldError) {
      return formatMessage(messages['error-message.could-not-find-field'], {
        fieldId: error.fieldId,
      });
    } else {
      return error.message;
    }
  };

  return <GenericErrorState message={getErrorMessage(error)} />;
};

export default DatabaseFatalError;
